import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Facebook, Instagram, MapPin } from 'lucide-react';

const Footer = () => {
  // Services for the footer links
  const services = [
    { id: 'driveways', title: 'Driveways' },
    { id: 'houses', title: 'Houses and Roof Softwashing' },
    { id: 'fences', title: 'Fences' },
    { id: 'paver-installation', title: 'Paver Installation and Sealing' },
  ];

  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="space-y-8 xl:col-span-1">
            <div className="text-white font-bold text-2xl">Floboys Surface Cleaning LLC</div>
            <p className="text-gray-300 text-base">
              Professional pressure washing services for residential and commercial properties.
              Restoring beauty one surface at a time.
            </p>
            <div className="flex space-x-6">
              <a href="https://facebook.com/Floboys Surface Cleaning LLC" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-white">
                <Facebook size={24} />
              </a>
              <a href="https://instagram.com/Floboys_surfacecleaning" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-white">
                <Instagram size={24} />
              </a>
            </div>
          </div>
          
          <div className="mt-12 grid grid-cols-2 gap-8 xl:mt-0 xl:col-span-2">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">Services</h3>
                <ul className="mt-4 space-y-4">
                  {services.map((service) => (
                    <li key={service.id}>
                      <Link to={`/services#${service.id}`} className="text-base text-gray-300 hover:text-white">
                        {service.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              
              <div className="mt-12 md:mt-0">
                <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">Company</h3>
                <ul className="mt-4 space-y-4">
                  <li>
                    <Link to="/" className="text-base text-gray-300 hover:text-white">
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link to="/about" className="text-base text-gray-300 hover:text-white">
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link to="/gallery" className="text-base text-gray-300 hover:text-white">
                      Gallery
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact" className="text-base text-gray-300 hover:text-white">
                      Contact
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            
            <div>
              <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">Contact Us</h3>
              <ul className="mt-4 space-y-4">
                <li className="flex">
                  <Phone size={20} className="flex-shrink-0 text-gray-400 mr-3" />
                  <a href="tel:+14079063215" className="text-base text-gray-300 hover:text-white">
                    (407) 906-3215
                  </a>
                </li>
                <li className="flex">
                  <Mail size={20} className="flex-shrink-0 text-gray-400 mr-3" />
                  <a href="mailto:floboyspressurewashing@gmail.com" className="text-base text-gray-300 hover:text-white">
                    floboyspressurewashing@gmail.com
                  </a>
                </li>
                <li className="flex">
                  <MapPin size={20} className="flex-shrink-0 text-gray-400 mr-3" />
                  <span className="text-base text-gray-300">
                    Serving All Local Areas
                  </span>
                </li>
              </ul>
              <div className="mt-8">
                <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">Follow Us</h3>
                <div className="mt-4 flex items-center">
                  <a href="https://facebook.com/Floboys Surface Cleaning LLC" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-forest-300 mr-4">
                    <span className="flex items-center">
                      <Facebook size={20} className="mr-2" />
                      Floboys Surface Cleaning LLC
                    </span>
                  </a>
                </div>
                <div className="mt-2 flex items-center">
                  <a href="https://instagram.com/Floboys_surfacecleaning" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-forest-300">
                    <span className="flex items-center">
                      <Instagram size={20} className="mr-2" />
                      Floboys_surfacecleaning
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-12 border-t border-gray-700 pt-8">
          <p className="text-base text-gray-400 text-center">
            &copy; {new Date().getFullYear()} Floboys Surface Cleaning LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;